import { render, staticRenderFns } from "./Site404.vue?vue&type=template&id=38650b72&scoped=true&"
import script from "./Site404.vue?vue&type=script&lang=js&"
export * from "./Site404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38650b72",
  null
  
)

export default component.exports